const u = (id, w = 2000) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

// Placeholder stock photography in Amalfi-coast style.
// Replace 1:1 with the real VillaFlow / Balena Blu assets when provided.
export const IMG = {
  cover: u("photo-1499678329028-101435549a4e", 2400),
  closing: u("photo-1516483638261-f4dbaf036963", 2400),
  standard: u("photo-1571896349842-33c89424de2d", 1400),
  collection: [
    u("photo-1613490493576-7fde63acd811", 1200),
    u("photo-1600607687939-ce8a6c25118c", 1200),
    u("photo-1540541338287-41700207dee6", 1200),
    u("photo-1414235077428-338989a2e8c0", 1200),
  ],
};
